/**
 * The available surfaces.
 *
 * base: The default surface.
 * alternate: An alternate variation of the base surface.
 * inverse: An inverted variation of the base surface.
 * contrast: A high-contrast variation of the base surface.
 */
export const surfaces = {
  base: 'surface-base',
  alternate: 'surface-alternate',
  inverse: 'surface-inverse',
  contrast: 'surface-contrast',
} as const;

/**
 * The available surface modes.
 *
 * legacy: The legacy surface mode.
 * native: The native surface mode.
 */
export const surfaceModes = ['legacy', 'native'] as const;

type SurfaceProp = {
  /** The surface type that wraps the component */
  type: Surfaces;
};
export type WithSurface<T> = T & SurfaceProp;
export type WithOptionalSurface<T> = T & Partial<SurfaceProp>;
export type Surfaces = keyof typeof surfaces;

/** Stable list of surface keys, captured before docgen may mutate the surfaces object. */
export const surfaceKeys = Object.keys(surfaces) as Surfaces[];
